import { APP_TYPES } from '@config';
import calculateTabService from '@services/requests/calculate-tab.service';
import { 
  setCalculateGridSelectedItem, 
  resetFEMResults, 
  setProfileResistance, 
  setCalculateGridSelectedNailItem 
} from '@reducers/selectors/calculate/actions';
import { compareBy } from '@views/Calculate/components/CalculateAnchorSelection/index';
import { compareBy as nailsCompareBy } from '@views/Calculate/components/CalculateNailsSelection/index';
import { EventManager, EVENTS } from '@components/Events/events';
import tabs from './../../../App/tabs';

export const SET_CALCULATE_RESPONSE = 'SET_CALCULATE_RESPONSE';
export const SET_SPINNER = 'SET_SPINNER';
export const SET_SORTING_METHOD = 'SET_SORTING_METHOD';
export const SET_NAILS_SORTING_METHOD = 'SET_NAILS_SORTING_METHOD';
export const SET_WEB_CALCULATE_STATE = 'SET_WEB_CALCULATE_STATE';
export const RESET_CALCULATE_STATE = 'RESET_CALCULATE_STATE';
export const SET_SCENE_SPINNER = 'SET_SCENE_SPINNER';
export const SET_STEEL_TYPES = 'SET_STEEL_TYPES';
export const SET_REPORT_PROGRESS = 'SET_REPORT_PROGRESS';

/*
  Action creators
 */
export function resetCalculateState() {
  return { type: RESET_CALCULATE_STATE };
}
export function setCalculateState(state) {
  return { type: SET_WEB_CALCULATE_STATE, state };
}
export function initCalculateTab(res) {
  return (dispatch, getState) => {
    dispatch(setSpinner(true));
    const state = getState();
    dispatch({ type: SET_CALCULATE_RESPONSE, res: [] }); // reset results
    dispatch(resetFEMResults());

    var calculationIntervalId = setInterval(() => {
      calculateTabService.keepCalculationRunning();
    }, 10000);

    var wasTabSwitched = false;
    var calculationEnded = false;
    EventManager.once(EVENTS.TAB_SWITCHED, (tab) => {
      if (tab !== tabs.CALCULATE && !calculationEnded) {
        wasTabSwitched = true;
        calculateTabService.cancelCalculation();
        clearInterval(calculationIntervalId);
      }
    });
    dispatch(getSteelTypes()); //update steel types filter


    return calculateTabService.initCalculateTab(prepareState(state), state.main.appType)
      .then(res => {
        clearInterval(calculationIntervalId);
        calculationEnded = true;
        if (wasTabSwitched) {
          if (getState().main.activeTab !== tabs.CALCULATE)
            dispatch(setSpinner(false));
          return;
        }
        if (res) {
          dispatch({ type: SET_CALCULATE_RESPONSE, res: res[0] });

          if (res[0] && (res[0][0] || (res[0].AnchorDesignResults && res[0].AnchorDesignResults[0]))) {
            let anchorDesignResults = res[0].AnchorDesignResults || res[0];
            let foundPrevious = false;
            const previousItem = state.selectors.calculate[state.main.appType].gridSelectedItem;
            if (previousItem) {
              let item;
              if (state.main.appType !== APP_TYPES.REBAR_REINFORCEMENT) {
                item = anchorDesignResults.find((res) => {
                  return res.IndexProduct === previousItem.IndexProduct &&
                    res.IndexDiameter === previousItem.IndexDiameter &&
                    res.IndexType === previousItem.IndexType;
                });
              } else {
                item = anchorDesignResults.find((res) => {
                  return res.DatabaseName === previousItem.DatabaseName;
                });
              }

              if (item) {
                foundPrevious = true;
                dispatch(setCalculateGridSelectedItem(item));
              }
            }

            if (!foundPrevious) {
              let firstItem;
              // initial state of the application
              // for rebar application, if the current key is not available for rebar, change the key to default: Anchorage Lbd
              if (state.main.appType === APP_TYPES.REBAR_REINFORCEMENT &&
                (state.webServices.calculate.sortBy === null ||
                  state.webServices.calculate.sortBy !== 'DisplayName' &&
                  state.webServices.calculate.sortBy !== 'Diameter' &&
                  state.webServices.calculate.sortBy !== 'Lbd' &&
                  state.webServices.calculate.sortBy !== 'Status')) {
                dispatch(setSortingMethod('Lbd', false));
                firstItem = anchorDesignResults.sort(compareBy('Lbd', false))[0];
                // for other applications, if the current key is available only for rebar, change the key to default: Utilization (Beta)
              } else if (state.main.appType !== APP_TYPES.REBAR_REINFORCEMENT &&
                (state.webServices.calculate.sortBy === null ||
                  state.webServices.calculate.sortBy === 'DisplayName' ||
                  state.webServices.calculate.sortBy === 'Diameter' ||
                  state.webServices.calculate.sortBy === 'Lbd')) {
                dispatch(setSortingMethod('Beta', true));
                firstItem = anchorDesignResults.sort(compareBy('Beta', true))[0];
              } else {
                firstItem = 
                  anchorDesignResults.sort(compareBy(state.webServices.calculate.sortBy, state.webServices.calculate.isReverse))[0];
              }
              dispatch(setCalculateGridSelectedItem(firstItem));
            }
          }
          
          if (res[0] && res[0].NailsDesignResults && res[0].NailsDesignResults[0]) {
            let nailsDesignResults = res[0].NailsDesignResults;
            let foundPrevious = false;
            const previousItem = state.selectors.calculate[state.main.appType].gridSelectedNailItem;
            if (previousItem) {
              let item = nailsDesignResults.find((nailRes) => {
                return nailRes.IndexProduct === previousItem.IndexProduct &&
                  nailRes.IndexDiameter === previousItem.IndexDiameter &&
                  nailRes.IndexType === previousItem.IndexType;
              });

              if (item) {
                foundPrevious = true;
                dispatch(setCalculateGridSelectedNailItem(item));
              }
            }

            if (!foundPrevious) {
              let firstItem;
              if (state.webServices.calculate.nails.sortBy === null) {
                dispatch(setNailsSortingMethod('Interaction', true));
                firstItem = nailsDesignResults.sort(nailsCompareBy('Interaction', true))[0];
              } else {
                firstItem = nailsDesignResults.sort(
                  nailsCompareBy(state.webServices.calculate.nails.sortBy, state.webServices.calculate.nails.isReverse)
                )[0];
              }
              dispatch(setCalculateGridSelectedNailItem(firstItem));
            }
          }

          if (res[1]) {
            dispatch(setProfileResistance(res[1]));
          }
        }

        dispatch(setSpinner(false));
        return res;
      },
        () => {
          clearInterval(calculationIntervalId);
          calculationEnded = true;
        });
  };
}

export function setSpinner(isSpinning) {
  return (dispatch) => {
    dispatch({ type: SET_SPINNER, isSpinning: isSpinning });
  };
}

export function setSortingMethod(sortBy, isReverse) {
  return (dispatch) => {
    dispatch({ type: SET_SORTING_METHOD, sortBy: sortBy, isReverse: isReverse });
  };
}

export function setNailsSortingMethod(sortBy, isReverse) {
  return (dispatch) => {
    dispatch({ type: SET_NAILS_SORTING_METHOD, sortBy: sortBy, isReverse: isReverse });
  };
}

export function prepareState(state) {
  const config = {
    [APP_TYPES.GENERAL_CALCULATION]: null,
    [APP_TYPES.BRACKET_ATTACHMENT]: null,
    [APP_TYPES.SAFETY_BARRIER]: null,
    [APP_TYPES.REBAR_REINFORCEMENT]: null
  };

  const application = state.selectors.application[state.main.appType];
  const dimension = state.selectors.dimension[state.main.appType];
  const material = state.selectors.material[state.main.appType];
  const loads = state.selectors.loads[state.main.appType];
  const design = state.selectors.design[state.main.appType];
  const calculate = state.selectors.calculate[state.main.appType];

  config[state.main.appType] = {
    application,
    dimension,
    material,
    loads,
    design,
    calculate: {
      gridSelectedItem: calculate.gridSelectedItem,
      FEM: calculate.FEM,
      // extendTimeout: state.main.extendTimeout
    }
  };

  // VladP: The console will keep a reference to the object so you will be able to expand it - memory leak
  // Use only during debugging if necessary
  // console.log(config);

  return config;
}

export function setSceneSpinner(value) {
  return (dispatch) => {
    dispatch({ type: SET_SCENE_SPINNER, value });
  };
}

export function getSteelTypes() {
  return (dispatch) => {
    return calculateTabService.getSteelTypes()
      .then(steelTypes => {
        if (steelTypes && steelTypes.length) {
          dispatch({ type: SET_STEEL_TYPES, value: steelTypes });
        }
      });
  };
}

export function setReportProgress(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_REPORT_PROGRESS, value });
  };
}



// WEBPACK FOOTER //
// ./src/reducers/web-services/calculate/actions.js